import ApplicationQueue from './ApplicationQueue';
export default ApplicationQueue;